import React from 'react';

import logo from 'assets/Overwatch_App_Logo_By_RescAlert_TM.png';
import { FaApple, FaAt, FaFacebook, FaGoogle, FaUser } from 'react-icons/fa6';

const LoginSelector = ({ onMethodSelect }) => {
  return (
    <div
      style={{
        // width: "300px",
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h2
        style={{
          marginBottom: 10,
          marginTop: 0,
        }}
      >
        Sign In to
      </h2>
      <img
        alt={'RescAlert Logo'}
        src={logo}
        style={{
          width: '100%',
          marginBottom: 40,
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <button
          type='submit'
          style={{
            background: '#436c9a',
            padding: 10,
            borderRadius: 10,
            border: 'none',
            width: '50%',
            color: '#fff',
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
          onClick={() => onMethodSelect('google')}
        >
          <FaGoogle />
          Google
        </button>
        {/* <button
          type='submit'
          style={{
            background: '#436c9a',
            padding: 10,
            borderRadius: 10,
            border: 'none',
            width: '50%',
            color: '#fff',
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
          onClick={() => setMethod('facebook')}
        >
          <FaFacebook />
          Facebook
        </button> */}
        {/* <button
          type='submit'
          style={{
            background: 'grey',
            padding: 10,
            borderRadius: 10,
            border: 'none',
            width: '50%',
            color: '#fff',
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
          onClick={() => setMethod('apple')}
        >
          <FaApple />
          Apple
        </button> */}
        <button
          type='submit'
          style={{
            background: '#436c9a',
            padding: 10,
            borderRadius: 10,
            border: 'none',
            width: '50%',
            color: '#fff',
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
          }}
          onClick={() => onMethodSelect('native')}
        >
          <FaAt />
          Email
        </button>
      </div>
    </div>
  );
};

export default LoginSelector;
